import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SlickConfirmDialogModule } from "@slick-components";
import { TaxRatesService } from "@services";

import { AddressValidationDialogComponent } from "./address-validation-dialog.component";

@NgModule({
	imports: [
		CommonModule,
		SlickConfirmDialogModule
	],
	declarations: [AddressValidationDialogComponent],
	providers: [TaxRatesService],
	exports: [AddressValidationDialogComponent]
})
export class AddressValidationDialogModule { }

export { AddressValidationDialogComponent }
export type { IValidatableAddress, IAddressValidationDialogResult } from "./address-validation-dialog.component";
